import { BinderVariant } from "@/types/binders";
import { Trash2, X } from "lucide-react";
import { useCallback, useMemo, useState } from "react";
import { DeleteBindeItemDialog } from "../DeleteBindeItemDialog";

interface Props {
  binderItem: BinderVariant;
  onSelect: (binderItem: BinderVariant) => void;
}

export function EditBinderVariantsModalItem({ binderItem, onSelect }: Props) {
  const [isOpenDeleteBindeItemDialog, setIsOpenDeleteBindeItemDialog] =
    useState(false);

  const variantName = binderItem.variant.condition.name;
  const gradedCard = binderItem.graded_card;
  const variantPrice = binderItem.variant.price;

  const normalizedPrice = useMemo(() => {
    const gradedCardPrice = gradedCard?.price;

    return gradedCardPrice || variantPrice;
  }, [gradedCard?.price, variantPrice]);

  const grade = useMemo(() => {
    if (binderItem.grading_company && binderItem.grade) {
      return `${binderItem.grading_company.name} ${binderItem.grade.name}`;
    }

    return null;
  }, [binderItem.grade, binderItem.grading_company]);

  const formattedPrice = useMemo(() => {
    if (!normalizedPrice) {
      return null;
    }

    return Number(normalizedPrice).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }, [normalizedPrice]);

  const purchasePrice = useMemo(() => {
    if (!binderItem.purchase_price) {
      return null;
    }

    return Number(binderItem.purchase_price).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }, [binderItem.purchase_price]);

  const onDeleteBindeItem = useCallback(() => {
    setIsOpenDeleteBindeItemDialog(true);
  }, []);

  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <button
          className="text-left border border-input rounded-lg p-2 hover:bg-muted transition-all duration-300 grid gap-2 flex-1"
          onClick={() => onSelect(binderItem)}
        >
          <span className="flex items-center justify-between">
            <div>
              {grade && <span className="text-fluorescent-pink">{grade} </span>}
              <span>{variantName}</span>
            </div>
            <span className="text-green-600">{formattedPrice}</span>
          </span>
          {purchasePrice && (
            <span className="text-muted-foreground text-sm">
              <span>Purchase Price: </span>
              <span>{purchasePrice}</span>
            </span>
          )}
        </button>
        <button
          className="text-red-600 rounded-lg  aspect-square p-3"
          onClick={onDeleteBindeItem}
        >
          <Trash2 className="w-5 h-5" />
        </button>
      </div>
      <DeleteBindeItemDialog
        open={isOpenDeleteBindeItemDialog}
        onOpenChange={setIsOpenDeleteBindeItemDialog}
        binderItem={binderItem}
      />
    </>
  );
}
